export class ILookup {
    id: string;
    name: string;
    type: string;
    isDefault?: boolean;
    order?:number;
    constructor(id: string, name: string, type:string='', isDefault:boolean=null, order:number=0){
        this.id = id;
        this.name = name;
        this.type = type;
        this.isDefault = isDefault;
        this.order = order;
    }
}
export class LookupList {
    lookupType: string;
    lookupData: ILookup[];
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/lookup.ts